import { useEffect, useState } from "react";
import { Cloud, HardDrive } from "lucide-react";
import { api, fmtSize } from "../../lib/api";

const gb = (b) => `${(b / 1024 ** 3).toFixed(2)} GB`;

export const StorageMeter = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/storage").then((r) => setS(r.data)).catch(() => setS(null));
  }, [refreshKey]);
  if (!s) return null;
  const used = s.emergent?.used ?? 0;
  const quota = s.emergent?.quota ?? 1;
  const pct = Math.min(100, (used / quota) * 100);
  const bar = pct > 85 ? "bg-white" : "bg-[#1FD1FF]";
  const r2 = s.r2 || {};

  return (
    <div data-testid="storage-meter" className="grid md:grid-cols-2 gap-4 mb-12">
      <div className="border border-white/10 bg-[#0A1424] p-5">
        <div className="flex items-center justify-between mb-3">
          <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#A8B3C4]"><HardDrive className="w-4 h-4" />Almacenamiento incluido</span>
          <span data-testid="storage-meter-percent" className="font-display text-3xl">{pct.toFixed(1)}%</span>
        </div>
        <div className="h-2 bg-white/10"><div className={`h-full ${bar} transition-[width] duration-700`} style={{ width: `${Math.max(pct, 0.5)}%` }} /></div>
        <p data-testid="storage-meter-used" className="mt-3 text-sm text-[#E2E8F0]">{gb(used)} de {gb(quota)} usados</p>
        <p className="mt-1 text-xs text-[#A8B3C4]">Incluye archivos eliminados: este almacenamiento no permite borrarlos de verdad.</p>
        {pct > 85 && <p data-testid="storage-meter-warning" className="mt-2 text-sm text-white">Te queda poco espacio. Conecta Cloudflare R2 para seguir subiendo.</p>}
      </div>
      <div className="border border-white/10 bg-[#0A1424] p-5">
        <div className="flex items-center justify-between mb-3">
          <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-[#A8B3C4]"><Cloud className="w-4 h-4" />Cloudflare R2</span>
          <span data-testid="r2-status" className={`font-mono text-xs uppercase px-2 py-1 ${r2.connected ? "bg-[#1FD1FF] text-black" : "border border-white/20 text-[#A8B3C4]"}`}>
            {r2.connected ? "Conectado" : r2.configured ? "Error de conexión" : "Sin conectar"}
          </span>
        </div>
        {r2.connected ? (
          <p data-testid="r2-used" className="text-sm text-[#E2E8F0]">{fmtSize(r2.used)} en {r2.files} archivos. Las subidas nuevas van a R2, sin límite de 5 GB.</p>
        ) : (
          <p className="text-sm text-[#A8B3C4]">{r2.configured ? `Revisa tus claves de R2. ${r2.error || ""}` : "Las subidas nuevas se guardan en el almacenamiento incluido (5 GB)."}</p>
        )}
      </div>
    </div>
  );
};
